import React from 'react';
import { CheckCircle } from 'lucide-react';
export function Benefits() {
  return <section className="py-[50px] px-[15px] relative bg-cover bg-center bg-[url('https://app.heylloyd.io/public/files/openrouter-generated-image-1770512736972.png')]" data-id="element-40">
      <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.7)] via-[rgba(0,0,0,0.3)] to-[rgba(0,0,0,0.7)] z-[1]" data-id="element-41"></div>
      <div className="container max-w-full mx-auto px-[15px] relative z-[2]" data-id="element-42">
        <div className="bg-gradient-to-r from-[#8B4513] to-[#654321] text-white p-[12px_20px] text-center font-[700] text-[18px] uppercase rounded-[8px] mb-[25px] shadow-[0_5px_15px_rgba(139,69,19,0.3)] w-full" data-id="element-43">
          La Biblia del Café existe para esto
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[15px]" data-id="element-44">
          <div className="bg-[rgba(255,255,255,0.85)] p-[20px] rounded-[8px] text-center shadow-[0_4px_10px_rgba(0,0,0,0.05)] border-b-[4px] border-[#10B981]" data-id="element-45">
            <CheckCircle className="text-[28px] text-[#10B981] mb-[12px] block mx-auto" data-id="element-46" />
            <div data-id="element-47">
              Para que <strong data-id="element-48">dejes de adivinar</strong> y empieces a tener
              control real sobre tu taza.
            </div>
          </div>

          <div className="bg-[rgba(255,255,255,0.85)] p-[20px] rounded-[8px] text-center shadow-[0_4px_10px_rgba(0,0,0,0.05)] border-b-[4px] border-[#10B981]" data-id="element-49">
            <CheckCircle className="text-[28px] text-[#10B981] mb-[12px] block mx-auto" data-id="element-50" />
            <div data-id="element-51">
              Una guía digital premium pensada para gente real:{' '}
              <strong data-id="element-52">sin teoría barista innecesaria</strong> y sin tirar granos
              a la basura.
            </div>
          </div>

          <div className="bg-[rgba(255,255,255,0.85)] p-[20px] rounded-[8px] text-center shadow-[0_4px_10px_rgba(0,0,0,0.05)] border-b-[4px] border-[#10B981]" data-id="element-53">
            <CheckCircle className="text-[28px] text-[#10B981] mb-[12px] block mx-auto" data-id="element-54" />
            <div data-id="element-55">
              Un sistema progresivo en 3 capas claras:{' '}
              <strong data-id="element-56">
                Fundamentos mínimos + Recetas base + Diagnóstico BÍBLICO.
              </strong>
            </div>
          </div>

          <div className="bg-[rgba(255,255,255,0.85)] p-[20px] rounded-[8px] text-center shadow-[0_4px_10px_rgba(0,0,0,0.05)] border-b-[4px] border-[#10B981]" data-id="element-57">
            <CheckCircle className="text-[28px] text-[#10B981] mb-[12px] block mx-auto" data-id="element-58" />
            <div data-id="element-59">
              Árbol visual <strong data-id="element-60">Sabor → Causa → Ajuste</strong> que te dice
              exactamente qué tocar cuando algo sale mal.
            </div>
          </div>
        </div>
      </div>
    </section>;
}